import React, { use, useEffect, useState, useMemo, useRef } from 'react'
import Logo from "../../assets/OGOGLOGOG.svg"; // Ensure the logo path is correct
import { Button, Input, Select, SelectItem, Chip, Checkbox, Tooltip, Spinner } from '@heroui/react';
import { AddIcon, CloseIcon, KeyboardArrowDownIcon } from '../../utils/svgIcons';
import ModalBox from '../../components/PopupModals/Modal';
import Loading from '../LoadinScreen/Loading';
import toast, { Toaster } from 'react-hot-toast';
import { IoSaveOutline, IoCheckmark } from "react-icons/io5";
import { DateRangePicker } from 'materialui-daterange-picker';
import DateRangModal from '../PopupModals/DateRangModal';
import { useAuth } from '../../hooks/useAuth';
import { useDispatch } from 'react-redux';
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";


function FilterData({ isSidebarOpen, leadType, setIsSidebarOpen, filterData, setFilter, filter, openDateRangeKey, handleConfirmFilter, isOpen, onOpen, onClose, applyFilter, addFilter, setAddFilter, search, setSearch, searchTerm, setSearchTerm, setSelectedFilters, selectedFilters, toggleResetFilter, handleDateRangeChange, toggleDateRange, isDateRangeOpen, dateRange, setIsDateRangeOpen, setDateRange, savePreference, fetchPreferences, deletePreference, setDateRangeFilters, dateRangeFilters, setCheckedFilters, checkedFilters, isDropdownLoading }) {
	const dispatch = useDispatch();

	const [showSaveModal, setShowSaveModal] = useState(false);
	const [filterSetName, setFilterSetName] = useState("");
	const [showConfirmSave, setShowConfirmSave] = useState(false);
	const { savedFilters, status, user } = useAuth();
	const [activeSavedFilterName, setActiveSavedFilterName] = useState(null);
	const isFirstRender = useRef(true);

	// Additional Filters
	const handleCheckboxToggle = (filterKey) => {
		setCheckedFilters((prev) => {
			const nextState = !prev[filterKey];
			if (!nextState) {
				const incDateKey = `${filterKey}_inc_date`;
				setFilter((prevFilter) => ({
					...prevFilter,
					[incDateKey]: null
				}));
			}
			return {
				...prev,
				[filterKey]: nextState
			};
		});
	};

	// Store the selected filters in local storage
	useEffect(() => {
		if (isSidebarOpen) {
			dispatch(fetchPreferences(user?._id))
		}
		// const storedFilters = JSON.parse(localStorage.getItem('savedFilters')) || {};
		// setSavedFilters(storedFilters);
	}, [isSidebarOpen]);


	const toggleAddFilter = () => {
		setAddFilter(!addFilter);
	};

	const toggleApplyFilter = () => {
		setAddFilter(false);
		onOpen();
	};

	const toggleSearch = () => {
		setSearch(!search);
	};

	const toggleCancelFilter = () => {
		setIsSidebarOpen(false);
	}

	const filteredItems = [...new Set(Object.keys(filter)
		.filter((key) => {
			if (!searchTerm) return true;
			const normalizedKey = key.toLowerCase().replace(/_/g, " ");
			const normalizedSearch = searchTerm.toLowerCase().replace(/_/g, " ");
			return normalizedKey.includes(normalizedSearch);
		})
		.map((key) =>
			key
				.replace(/_/g, " ") // Replace underscores with spaces
				.replace(/\b\w/g, (char) => char.toLowerCase()) // Capitalize first letter of each word
		))];

	const handleSelectFilter = (item) => {
		if (!selectedFilters.includes(item)) {
			setSelectedFilters((prev) => [...prev, item]);
		}
		setSearchTerm(""); // Clear search after selection
		setSearch(false);
	};

	// Function to remove a selected filter and clear its value
	const handleRemoveFilter = (key) => {
		const incDateKey = `${key}_inc_date`;
		setFilter((prev) => ({
			...prev,
			[key]: [],
			[incDateKey]: null,
		}));
		if (setCheckedFilters) {
			setCheckedFilters((prev) => ({
				...prev,
				[key]: false
			}));
		}
		setSelectedFilters((prev) => prev.filter((item) => item !== key));
	};

	useEffect(() => {
		if (isFirstRender.current) {
			isFirstRender.current = false;
			return;
		}
		if (selectedFilters.length === 0) {
			toggleResetFilter();
		}
	}, [selectedFilters.length]);

	const removeaddFilter = () => {
		setAddFilter(false);
		setSearchTerm("");
		setAddFilter(false);
		setSearch(false);
	};

	// Handle Filter
	const handleFilterFields = (field, value) => {
		if (!field) return;
		setFilter(prev => ({ ...prev, [field]: value }));
	};

	// Handle SaveFilter
	const saveFilterSet = () => {
		if (!filterSetName.trim()) return;

		// const storedFilters = JSON.parse(localStorage.getItem('savedFilters')) || {};
		// if (!storedFilters[leadType]) {
		//   storedFilters[leadType] = [];
		// }

		const isDuplicate = savedFilters[leadType]?.some(f => f.name === filterSetName);
		if (isDuplicate) {
			toast.error("A filter with this name already exists!");
			return;
		}

		const cleanedFilter = Object.fromEntries(
			Object.entries(filter).filter(([key, value]) => {
				if (Array.isArray(value)) return value.length > 0;
				if (typeof value === 'object' && value !== null) return Object.keys(value).length > 0;
				return value !== "" && value !== null && value !== undefined;
			})
		);

		const saveFilterData = {
			adminId: user?._id,
			leadType,
			type: 'filter',
			name: filterSetName,
			data: { ...cleanedFilter }
		}

		dispatch(savePreference(saveFilterData)).then((res) => {
			setShowConfirmSave(false);
			setFilterSetName("");
			toast.success(res?.payload?.message);
			setTimeout(() => {
				setShowSaveModal(false);
			}, 500);
			dispatch(fetchPreferences(user?._id))
		}).catch((err) => {
			console.error('Error:', err);
		})

		// const newFilterSet = { name: filterSetName, filters: { ...filter } };

		// storedFilters[leadType].push(newFilterSet);

		// setSavedFilters(storedFilters);
		// localStorage.setItem('savedFilters', JSON.stringify(storedFilters));

		// const updatedFilters = [...savedFilters, newFilterSet];
		// setSavedFilters(updatedFilters);
		// localStorage.setItem(`savedFilters${leadType}`, JSON.stringify(updatedFilters));

	};

	const confirmApplyFilter = () => {
		setShowSaveModal(true);
	};

	const applySavedFilter = (savedFilter) => {
		// Ensure filter updates correctly
		setFilter({ ...savedFilter.filters });

		// Update selectedFilters properly
		const selectedKeys = Object.keys(savedFilter.filters).filter(
			key => Array.isArray(savedFilter.filters[key])
				? savedFilter.filters[key].length > 0
				: savedFilter.filters[key] !== null // Include non-array values like dates
		);
		setSelectedFilters(selectedKeys);

		// Restore checkbox states for incremental dates
		if (setCheckedFilters) {
			const nextCheckedFilters = {};
			Object.keys(savedFilter.filters).forEach((key) => {
				if (key.endsWith('_inc_date')) {
					const range = savedFilter.filters[key];
					if (range?.startDate && range?.endDate) {
						const parentKey = key.replace(/_inc_date$/, '');
						nextCheckedFilters[parentKey] = true;
					}
				}
			}); 
			setCheckedFilters(nextCheckedFilters);
		}

		const dateFilterKey = Object.keys(savedFilter.filters).find(key => key.includes("date") && !key.endsWith("_inc_date"));
		if (dateFilterKey && savedFilter.filters[dateFilterKey]?.startDate && savedFilter.filters[dateFilterKey]?.endDate) {
			setDateRange({
				startDate: new Date(savedFilter.filters[dateFilterKey].startDate),
				endDate: new Date(savedFilter.filters[dateFilterKey].endDate),
			});
		} else {
			setDateRange({ startDate: null, endDate: null });
		}
	};

	useEffect(() => {
	}, [filter, selectedFilters, dateRange]); // Debug to ensure updates are applied

	const handleSaveFilter = () => {
		setShowConfirmSave(true)
	}

	const removeSavedFilter = (filterIndex) => {
		const saveFilterData = {
			adminId: user?._id,
			leadType,
			type: 'filter',
			index: filterIndex,
			name: savedFilters[leadType][filterIndex].name
		}

		dispatch(deletePreference(saveFilterData)).then((res) => {
			toast.success(res?.payload?.message);
			setTimeout(() => {
				dispatch(fetchPreferences(user?._id))
			}, 500);
		}).catch((err) => {
			console.error('Error:', err);
		})

		// setSavedFilters((prevFilters) => {
		//   if (!prevFilters[leadType]) return prevFilters;

		//   // Remove the filter from state
		//   const updatedFilters = {
		//     ...prevFilters,
		//     [leadType]: prevFilters[leadType].filter((_, index) => index !== filterIndex),
		//   };

		//   if (updatedFilters[leadType].length === 0) {
		//     delete updatedFilters[leadType];
		//   }

		//   // Save updated filters to localStorage
		//   localStorage.setItem("savedFilters", JSON.stringify(updatedFilters));

		//   return updatedFilters;
		// });

	};

	return (
		<div className="filter flex-col">
			<div className="filter-header">
				<div className="header-wrapper flex justify-between items-center border-b border-default-200 py-4 px-6">
					{applyFilter ? <p className='text-center font-medium text-large flex flex-col items-center justify-center w-full'>Please wait while we are <div class="text-loader"></div></p> : (
						<>
							<h4 className='text-2xl font-medium'>Filter</h4>
							<Button onPress={toggleAddFilter} startContent={<AddIcon />} isDisabled={addFilter || applyFilter} variant='bordered' className={`${(addFilter || applyFilter) ? 'bg-success text-white border-success-50' : ''}`}>Add Filter</Button>
						</>
					)}
				</div>
			</div>

			{status?.fetch === 'loading' ? (
				<div className="saved-filters px-6 py-4 border-b border-default-200 flex gap-2 whitespace-nowrap overflow-auto default-scrollbar">
					<Spinner color="success" />
					<p className="!text-success text-[20px]">Loading...</p>
				</div>
			) : (
				<>
					{savedFilters[leadType] && savedFilters[leadType].length > 0 && (
						<div className="saved-filters px-6 py-4 border-b border-default-200 flex gap-2 whitespace-nowrap overflow-auto default-scrollbar">
							{savedFilters[leadType].map((savedFilter, index) => (
								<Tooltip
									showArrow
									classNames={{
										base: ["before:bg-neutral-400 dark:before:bg-success"],
										content: ["py-2 px-4 ", "text-red font-medium from-white to-neutral-400"],
									}}
									content={`Saved Filter : ${savedFilter.name}`}
									placement="bottom"
								>
									<Chip key={index}
										className={`bg-success border-2 border-success text-white cursor-pointer transition-all duration-300 
                    ${activeSavedFilterName === savedFilter.name ? 'border-2 border-black shadow-md' : ''}`}
									>
										<div className="flex items-center gap-2">
											<span onClick={() => {
												setActiveSavedFilterName(savedFilter.name);
												applySavedFilter(savedFilter);
											}}>{savedFilter.name}</span>
											<span
												onClick={(e) => {
													e.stopPropagation(); // Prevent clicking on the chip itself
													removeSavedFilter(index);
												}}
											><CloseIcon width="15px" height="15px" className="!text-secondary" /></span>
										</div>
									</Chip>
								</Tooltip>
							))}
						</div>
					)}</>
			)}


			{applyFilter ? (
				<Loading />
			) : (
				<>
					<div className="filter-body default-scrollbar">
						{/* Search Input */}
						{addFilter && (
							<div className="search-filter-fields py-4 px-6 border-b border-default-200 flex items-center gap-5">
								<Input
									className="rounded-global w-full bg-green-50 text-lg"
									value={searchTerm}
									onFocus={() => setSearch(true)}
									// onChange={(e) => setSearchTerm(e.target.value)}
									onChange={(e) => {
										const value = e.target.value;
										if (value.toLowerCase().includes("additiondaterangefilter") || value.toLowerCase().includes("_inc_date")) {
											return;
										}
										setSearchTerm(value);
									}}
									// onPress={() => setSearch(true)}
									onPress={() => {
										if (searchTerm.toLowerCase().includes("additiondaterangefilter") || searchTerm.toLowerCase().includes("_inc_date")) {
											return;
										}
										setSearch(true);
									}}
									type="text"
									placeholder="Add Filter Fields..."
								/>
								<div className="remove text-3xl">
									<CloseIcon
										onClick={removeaddFilter}
										width="25"
										height="25"
										className="cursor-pointer text-gray-600 hover:text-red-500"
									/>
								</div>
							</div>
						)}

						{/* Search Results */}
						<div className="searchItems px-6 pr-14 relative">
							{(searchTerm || search) && (
								<div className="bg-white px-4 py-6 rounded-outSideglobal shadow-medium h-[250px] overflow-auto default-scrollbar absolute z-40">
									<h4 className="text-xl font-semibold pb-2 px-2">Select Filter</h4>
									<ul className="search-results ml-4 border-l border-gray-100 pl-4 ">
										{filteredItems.length > 0 ? (
											filteredItems
												.filter(item => {
													const normalized = item.toLowerCase().replace(/\s+/g, '_');
													return (
														item !== "additionDateRangeFilter" &&
														!normalized.endsWith('_inc_date')
													)
												})
												.map((item, index) => (
													<li
														key={index}
														onClick={() => handleSelectFilter(item)}
														className="border-b border-gray-100 py-3 px-2 last:border-none hover:bg-custom-bg cursor-pointer"
													>
														{item === 'pincodeExist' ? 'Pincode' : item === 'ola status' ? 'Ola Status' : item.charAt(0).toUpperCase() + item.slice(1).toLowerCase()}
													</li>

												))

										) : (
											<li className="p-2 text-gray-500">No results found</li>
										)}
									</ul>
								</div>
							)}
						</div>

						{/* Selected Filters Display */}
						{selectedFilters.length > 0 && (
							<div className="selected-items rounded-lg ">
								{/* <h4 className="text-lg font-semibold mb-2">Selected Filters</h4> */}
								<div className="flex flex-col items-start justify-between">
									{selectedFilters.map((filterKey, index) => {

										// Find the selected filter from filterData.generalFilter

										const formatTitle = (title) => {
											if (title?.toLowerCase() === 'ola_status') return 'Ola Status';
											return title
												.replace(/_/g, " ") // Replace underscores with spaces
												.replace(/\s+/g, " ") // Remove extra spaces
												.trim() // Trim leading and trailing spaces
												.replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize first letter of each word
										};
										const filterItem = filterData.generalFilter.find(
											(item) => {
												return (
													filterKey.replace(/\s/g, "_").toLowerCase() === item.title.replace(/\s/g, "_").toLowerCase()
												)
											}
										)

										return (
											<>
												{filterItem && (
													<>
														<div key={index} className="flex justify-between items-center w-full py-4 px-6 border-b-1 border-default-200" >
															<h4 className='font-bold text-large'>{formatTitle(filterItem.title) === 'PincodeExist' ? 'Pincode' : formatTitle(filterItem.title)}</h4>
															<Tooltip
																showArrow
																classNames={{
																	base: ["before:bg-neutral-400 dark:before:bg-secondary"],
																	content: ["py-2 px-4", "text-red font-light from-white to-neutral-400"],
																}}
																content={`Remove ${filterItem.title} filter`}
																placement="left"
															>
																<div>
																	<CloseIcon
																		onClick={() => handleRemoveFilter(filterKey)}
																		width="15"
																		height="15"
																		className="cursor-pointer text-gray-700 hover:text-red-500"
																	/>
																</div>
															</Tooltip>
														</div>

														{/* Render checkbox or dropdown based on filter type */}
														<div key={index} className="flex flex-col justify-between items-start w-full py-4 px-6 border-b-1 border-default-200" >

															{filterItem.type === "checkbox" && (
																<div className='flex- flex-col items-start justify-center'>
																	{filterItem.options.map((option) => (
																		<label key={option.value} className="flex items-center gap-2">
																			<Checkbox
																				classNames={{ icon: "text-white" }}
																				type="checkbox"
																				color="success"
																				isSelected={filter[filterKey]?.includes(option.value) || false} // Ensure it remains checked
																				onChange={(e) => {
																					setFilter((prev) => {
																						const selectedValues = prev[filterKey] || [];
																						const updatedValues = e.target.checked
																							? [...selectedValues, option.value] // Add value if checked
																							: selectedValues.filter((val) => val !== option.value); // Remove value if unchecked
																						return { ...prev, [filterKey]: updatedValues };
																					});
																				}}
																			>
																				{option.label}
																			</Checkbox>

																		</label>
																	))}
																</div>
															)}

															{filterItem.type === "dropdown" && (
																<>
																	{isDropdownLoading && (!filterItem.options || filterItem.options.length === 0) ? (
																		<div className="flex items-center gap-3 py-2 px-3 bg-[#f4f4f5] rounded-[12px] w-full h-[46px] transition-all duration-300">
																			<Spinner size="sm" color="success" />
																			<span className="text-[#71717a] text-sm">Loading options...</span>
																		</div>
																	) : filterItem.isSearchable ? (
																		<Autocomplete
																			popupIcon={<KeyboardArrowDownIcon className="text-default-500" />}
																			multiple
																			className='auto-complete-mlt'
																			fullWidth
																			id={filterItem.title}
																			options={filterItem.options || []}
																			getOptionLabel={(option) => String(option?.label ?? '')}
																			isOptionEqualToValue={(option, value) => option?.value == value?.value}
																			value={
																				(filter[filterKey] || []).map((val) =>
																					(filterItem.options || []).find((opt) => opt.value == val) || { label: String(val), value: val }
																				)
																			}
																			onChange={(event, newValue) => {
																				const selectedValues = newValue.map((item) => item.value);
																				handleFilterFields(filterKey, selectedValues);
																			}}
																			renderOption={(props, option, { selected }) => (
																				<li {...props} className={`${props.className} flex justify-between items-center ${selected ? 'bg-green-50 text-success' : ''}`}>
																					<span className="flex-grow text-left">{option.label}</span>
																					{selected && <IoCheckmark className="text-success text-lg shrink-0 ml-2" />}
																				</li>
																			)}
																			renderInput={(params) => (
																				<TextField
																					{...params}
																					className='mlt-ui-fix'
																					variant="standard"
																					label={formatTitle(filterItem.title)}
																					placeholder={`Select ${formatTitle(filterItem.title)}...`}
																					InputProps={{
																						...params.InputProps,
																						disableUnderline: true,
																					}}
																					sx={{
																						backgroundColor: "#f4f4f5",
																						borderRadius: "12px",
																						transition: "all 0.3s",
																						"&:hover": {
																							backgroundColor: "#e4e4e7"
																						},
																						"& .MuiInputBase-root": {
																							padding: "6px 12px !important",
																							minHeight: "44px",
																							display: "flex",
																							alignItems: "center",
																							flexWrap: "wrap", // Allow chips to wrap
																						},
																						"& .MuiInputBase-input": {
																							padding: "0px !important",
																							height: "100%",
																							width: "100%", // Ensure input takes space
																							"&::placeholder": {
																								color: "#71717a", // Ensure placeholder is visible
																								opacity: 1,
																							}
																						},
																						"& .MuiInputLabel-root": {
																							display: "none"
																						}
																					}}
																				/>
																			)}
																		/>
																	) : (
																		<Select
																			aria-label={formatTitle(filterItem.title)}
																			label={formatTitle(filterItem.title)}
																			selectionMode={filterItem.isSingleSelection ? "single" : "multiple"}
																			isMultiline={true}
																			selectedKeys={new Set(filter[filterKey] || [])}
																			onSelectionChange={(selected) => {
																				const selectedArray = Array.from(selected).map((item) => item.toString());
																				handleFilterFields(filterKey, selectedArray);
																			}}
																			listboxProps={{
																				itemClasses: {
																					base: [
																						"data-[selectable=true]:focus:bg-success",
																						"data-[selectable=true]:focus:text-white",
																						"data-[pressed=true]:opacity-70",
																						"data-[focus-visible=true]:ring-default-500",
																					],
																				},
																			}}
																			renderValue={(items) => (
																				<div className="flex flex-wrap gap-2">
																					{items.map((item) => {
																						const value = item.key || item?.props?.value;
																						const label = item?.textValue || item?.props?.value;
																						return (
																							<Chip
																								key={value}
																								className="bg-success text-white text-nowrap rounded-[9999px]"
																								onClose={() => {
																									const currentValues = filter[filterKey] || [];
																									const updatedValues = currentValues.filter((val) => val !== value);
																									handleFilterFields(filterKey, updatedValues);
																								}}
																								variant="flat"
																								radius="sm"
																								closeIcon={<CloseIcon width="15px" height="15px" className="!text-secondary" />}
																							>
																								{label}
																							</Chip>
																						);
																					})}
																				</div>
																			)}
																		>

																			{filterItem.options.map((option) => (
																				<SelectItem className="hover:focus:bg-success focus:bg-success text-balance" key={option.value} value={option.value}>
																					{option.label}
																				</SelectItem>
																			))}
																		</Select>
																	)}
																</>
															)}

															{filterItem.type === "input" && (
																<>
																	<div className='w-full'>
																		<Input
																			label={formatTitle(filterItem.title)}
																			type='number'
																			name='search'
																			value={Array.isArray(filter[filterKey]) ? "" : (filter[filterKey] || "")}
																			className='form-control w-100  d-inline'
																			onChange={(e) => {
																				setFilter({ ...filter, [filterKey]: e.target.value });
																			}}
																		/>
																	</div>
																</>
															)}

															{filterItem.type === "daterange" && (
																<>
																	<Button className='bg-[#f4f4f5] shadow-sm hover:bg-gray-100 !text-[10px]' variant="outlined" onPress={() => toggleDateRange(filterKey)} fullWidth>
																		{filter[filterKey]?.startDate && filter[filterKey]?.endDate
																			? `${new Date(filter[filterKey]?.startDate).toDateString()} - ${new Date(filter[filterKey]?.endDate).toDateString()}`
																			: 'Select Date Range'}
																	</Button>
																	{(isDateRangeOpen && openDateRangeKey === filterKey) && (
																		<DateRangModal
																			className="w-[800px]"
																			title={'Select DateRange'}
																			isOpen={isDateRangeOpen}
																			onOpen={() => toggleDateRange(filterKey)}
																			onClose={() => toggleDateRange(null)}
																		>
																			<div className="flex flex-col gap-[10px] dateRangePanel border border-gray-100">
																				<DateRangePicker
																					open={isDateRangeOpen}
																					toggle={() => toggleDateRange(filterKey)}
																					value={dateRange[filterKey] || ''}
																					onChange={(selected) => {
																						handleDateRangeChange(filterKey, selected);
																					}}
																					initialDateRange={dateRange[filterKey] || filter[filterKey]}
																				/>
																			</div>
																		</DateRangModal>
																	)}
																</>
															)}

														</div>

														{filterItem.allowDateRangeWithCheckbox && (
															<div
																className="flex flex-col justify-between items-start w-full py-4 px-6 border-b-1 border-default-200"
																key={index}
															>
																<Checkbox
																	classNames={{ icon: "text-white" }}
																	type="checkbox"
																	color="success"
																	isSelected={!!checkedFilters[filterItem.title]}
																	onChange={() => handleCheckboxToggle(filterItem.title)}
																>
																	Include <b>{formatTitle(filterItem.title)}</b> Date Range
																</Checkbox>

																{checkedFilters[filterItem.title] && (
																	<>
																		<Button
																			className="bg-[#f4f4f5] shadow-sm hover:bg-gray-100 !text-[10px] mt-3"
																			variant="outlined"
																			onPress={() => toggleDateRange(filterItem.title)}
																			fullWidth
																		>
																			{filter[`${filterItem.title}_inc_date`]?.startDate &&
																				filter[`${filterItem.title}_inc_date`]?.endDate
																				? `${new Date(
																					filter[`${filterItem.title}_inc_date`]?.startDate
																				).toDateString()} - ${new Date(
																					filter[`${filterItem.title}_inc_date`]?.endDate
																				).toDateString()}`
																				: "Select Date Range"}
																		</Button>

																		{(isDateRangeOpen && openDateRangeKey === filterItem.title) && (
																			<DateRangModal
																				className="w-[800px]"
																				title={`Select ${formatTitle(filterItem.title)} Date Range`}
																				isOpen={isDateRangeOpen}
																				onOpen={() => toggleDateRange(filterItem.title)}
																				onClose={() => toggleDateRange(null)}
																			>
																				<div className="flex flex-col gap-[10px] dateRangePanel border border-gray-100">
																					<DateRangePicker
																						open={isDateRangeOpen}
																						toggle={() => toggleDateRange(filterItem.title)}
																						value={filter[`${filterItem.title}_inc_date`] || ""}
																						onChange={(selected) =>
																							handleDateRangeChange(`${filterItem.title}_inc_date`, selected)
																						}
																						initialDateRange={
																							filter[`${filterItem.title}_inc_date`] || {}
																						}
																					/>
																				</div>
																			</DateRangModal>
																		)}
																	</>
																)}
															</div>
														)}

													</>
												)}
											</>
										);
									})}
								</div>
							</div>
						)}
					</div>

					<div className="filter-footer sticky bottom-0 border-t border-default-200 flex items-center justify-between py-4 px-6">
						{
							selectedFilters.length > 0 && (
								<>
									<div className="footer-wrapper flex items-center justify-between gap-2 ">
										<Tooltip
											showArrow
											content='Save Filters'
											placement="top"
											classNames={{
												base: ["before:bg-neutral-400 dark:before:bg-success"],
												content: ["py-2 px-4 ", "text-red font-medium from-white to-neutral-400"],
											}}
										>
											<div><IoSaveOutline onClick={handleSaveFilter} className='cursor-pointer text-2xl' /></div>
										</Tooltip>
									</div>
									<div className="footer-wrapper flex items-center justify-end gap-2 ">
										<Button onPress={toggleResetFilter}>Reset</Button>
										<Button onPress={toggleApplyFilter} className='bg-success text-white'>Apply</Button>
									</div>
								</>
							)
						}
					</div>

					<ModalBox
						title={'Confirm Filter Application'}
						isOpen={isOpen}
						onOpen={onOpen}
						onClose={onClose}
						handleConfirmUpdate={handleConfirmFilter}
					>
						<div className="flex flex-col gap-[5px]">
							<p>Are you sure! You want to <span className="text-amber-600 font-semibold"> apply this filters?</span></p>
							<p><span className='font-bold'>Filters</span> : <span className='text-success'>{selectedFilters.join(", ")}</span></p>
						</div>
					</ModalBox>
					{showSaveModal && (
						<ModalBox
							title={'Save Filter Set'}
							isOpen={showSaveModal}
							onOpen={() => setShowSaveModal(true)}
							onClose={() => setShowSaveModal(false)}
							handleConfirmUpdate={saveFilterSet}
							isLoading={status?.save === 'loading' ? true : false}
						>
							<div className="flex flex-col gap-[10px]">
								<Input type="text" placeholder="Enter filter set name..." value={filterSetName} onChange={(e) => setFilterSetName(e.target.value)} />
							</div>
						</ModalBox>
					)}
					{showConfirmSave && (
						<ModalBox
							title={'Want to save applied filters?'}
							isOpen={showConfirmSave}
							onOpen={() => setShowConfirmSave(true)}
							onClose={() => setShowConfirmSave(false)}
							handleConfirmUpdate={confirmApplyFilter}
						>
							<div className="flex flex-col gap-[5px]">
								<p className='text-amber-600 font-semibold'>Are you sure? You want to save this filter set.</p>
								<p><span className='font-bold'>Filters</span> : <span className='text-success'>{selectedFilters.join(", ")}</span></p>
							</div>
						</ModalBox>
					)}
				</>
			)
			}
			<Toaster
				position="top-right"
				reverseOrder={false}
			/>
		</div >
	);
}

export default FilterData